import { useParams, Navigate } from 'react-router-dom';
import PetApplication from 'src/pages/Reports/PetLicenseReport/index';
import ConstructionReportDetails from 'src/pages/Reports/ConstructionReport/ConstructionReport';
import FoodandBeveragesReportDetails from 'src/pages/Reports/FoodandBeveragesReport/FoodandBeveragesReport';
import CharitableSolicitationsReport from 'src/pages/Reports/CharitableSolicitationsReport/CharitableSolicitationsReport';
import SolicitorReport from 'src/pages/Reports/SolicitorReport/SolicitorReports';
import RoadOpeningReport from 'src/pages/Reports/RoadOpeningReport/RoadOpeningReport';
import ClerkVending from 'src/pages/Reports/ClerkVendingReport/ClerkVending';
import TreeRemovalReport from 'src/pages/Reports/TreeRemovalReport/TreeRemoval';
import PlanZoneReport from 'src/pages/Reports/PlanZoneReport/PlanZone';
import UsedCarDealer from 'src/pages/Reports/UsedCarReport/UserCarDealer';

const ReportRedirectHandler = () => {
    const { department, permit } = useParams();

    if (department === 'Planning Department' && permit === '1') {
        return <PlanZoneReport />;
    } else if (department === 'Engineering Department' && permit === '2') {
        return <RoadOpeningReport />;
    } else if (department === 'Engineering Department' && permit === '4') {
        return <TreeRemovalReport />;
    } else if (department === 'Clerk Department' && permit === '5') {
        return <CharitableSolicitationsReport />;
    } else if (department === 'Clerk Department' && permit === '6') {
        return <SolicitorReport />;
    } else if (department === 'Clerk Department' && permit === '7') {
        return <UsedCarDealer />;
    } else if (department === 'Clerk Department' && permit === '8') {
        return <ClerkVending />;
    } else if (department === 'Building or Construction Department' && permit === '9') {
        return <ConstructionReportDetails />;
    } else if (department === 'Department of Health or Animal Control' && permit === '10') {
        return <PetApplication />;
    }
    else if (department === 'Department of Health and Mental Hygiene' && permit === '12')
    {
        return <FoodandBeveragesReportDetails />;
    }

    // Redirect to the 404 or unauthorized page
    return <Navigate to="/unauthorized" />;
};

export default ReportRedirectHandler;
